<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
                    <el-input v-model="formDatas.asName" style="width: 120px;" size="mini" placeholder="名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.asNumber" style="width: 120px;" size="mini" placeholder="商户编码"
                        clearable></el-input>
                    <!-- <el-select size="mini" v-model="formDatas.ascId" clearable @change="partserch" placeholder="请选择商户城市"
                        style="width: 130px">
                        <el-option v-for="item in getAjefShopCityList_data" :key="item.ascId" :label="item.ascName"
                            :value="item.ascId"></el-option>
                    </el-select> -->
                    <el-select size="mini" v-model="formDatas.asStatusAgain" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="待提交" :value="1"></el-option>
                        <el-option label="保存" :value="2"></el-option>
                        <el-option label="待修改" :value="3"></el-option>
                        <el-option label="已提交" :value="4"></el-option>
                        <el-option label="已通过" :value="5"></el-option>
                    </el-select>

                    <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
                    <!-- <el-button type="warning" size="mini" style="" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="primary" size="mini" style=""
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="" @click="BulkDelete">批量删除</el-button> -->
          </div>
        </el-row>
        </div>
        <div class="tablemain" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="asaId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑商户' : '新增商户'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商户地址" prop="asCity">
                                <el-cascader v-model="asCity" :options="CityArr" :props="props" ref="cascader"
                                    @change="handleChange" @expand-change="expandChange"
                                    :placeholder="form.asCity == '' ? '请选择商户地址' : form.asCity"
                                    style="width: 80%;"></el-cascader>
                            </el-form-item>
                            <el-form-item label="商户名称" prop="asName">
                                <el-input v-model="form.asName" style="width: 80%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="营业执照照片" prop="asBaseBusinessLicense">
                                <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人身份证人面" prop="asBaseIdcardFace">
                                <my-uploadOnly ref="upload" @fileChange="fileChange2" :filearr="fileList2" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter2"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人身份证国徽" prop="asBaseIdcardNationalEmblem">
                                <my-uploadOnly ref="upload" @fileChange="fileChange3" :filearr="fileList3" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter3"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人手机号" prop="asBaseLegalPersonPhone">
                                <el-input v-model="form.asBaseLegalPersonPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="门头照片" prop="asBaseShopHeader">
                                <my-uploadOnly ref="upload" @fileChange="fileChange4" :filearr="fileList4" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter4"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="店内照片" prop="asBaseShopIn">
                                <my-uploadOnly ref="upload" @fileChange="fileChange5" :filearr="fileList5" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter5"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="对公账户户名" prop="asOpenName">
                                <el-input v-model="form.asOpenName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="对公账户账号" prop="asOpenBankAccount">
                                <el-input v-model="form.asOpenBankAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行名称" prop="asOpenBank">
                                <el-input v-model="form.asOpenBank" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户许可证" prop="asOpenBankImage">
                                <my-uploadOnly ref="upload" @fileChange="fileChange6" :filearr="fileList6" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter6"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="asEmail">
                                <el-input v-model="form.asEmail" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员姓名" prop="asAccountAdminName">
                                <el-input v-model="form.asAccountAdminName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员手机号" prop="asAccountAdmin">
                                <el-input v-model="form.asAccountAdmin" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="核销员姓名" prop="asAccountUserName">
                                <el-input v-model="form.asAccountUserName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="核销员手机号" prop="asAccountUser">
                                <el-input v-model="form.asAccountUser" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户结算类型" prop="asrtId">
                                <el-select v-model="form.asrtId" style="width: 80%;" placeholder="请选择商户结算类型">
                                    <el-option v-for="item in getAjefShopReceiptTypeList_data" :key="item.asrtId"
                                        :label="item.asrtReceiptTypeName" :value="item.asrtId"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="商户编码" prop="asNumber">
                                <el-input v-model="form.asNumber" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="主体信息" prop="asMainBody">
                                <el-input v-model="form.asMainBody" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经营信息" prop="asMainBusiness">
                                <el-input v-model="form.asMainBusiness" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="结算账户" prop="asSettlementAccount">
                                <el-input v-model="form.asSettlementAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户号" prop="asWechatAccount">
                                <el-input v-model="form.asWechatAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户地址" prop="asAddress">
                                <el-input v-model="form.asAddress" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>


        </div>
        <el-dialog :title="makeData.length > 0 ? '与移动存量客户关联商户' : '没有查询到,请自行到商家库查询'" :visible.sync="isMakeShow"
            width="70%" top="8vh" :close-on-click-modal="false">
            <div>
                <ve-table ref="vetable" :columns="columnsMake" :table-data="makeData" :max-height="tableHight"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    row-key-field-name="assyId" style="width: 100%" />
            </div>
            <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                <el-button type="danger" @click="handleRefuseCheck(theRow)" style="margin-left: 20%;">驳回审核</el-button>
                <el-button type="primary" @click="handleCheck(theRow)" style="margin-left: 150px;">
                    通过审核</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    updateAjefShopCheckBefore, getAjefShopCityList, addAjefShopAgain,
    getAjefShopAgainList, addAjefShop, updateAjefShop, deleteAjefShop, getAjefShopDetails, updateAjefShopAgainPass, updateAjefShopAgainNotPass, updateAjefShopCheckPassGift,
    getAjefUserShopList, addAjefUserShopAdmin, addAjefUserShopUser, updateAjefUserShop, deleteAjefUserShop, getAjefShopReceiptTypeList, getSysRegionList
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dialogFh: false,
            getAjefShopCityList_data: [],
            isMakeShow: false,
            columnsMake: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "assyName",
                    key: "assyName",
                    title: "商户名称",
                    align: "center",
                },

            ],
            makeData: [],
            asCity: '',
            props: {
                lazy: true,
                lazyLoad(node, resolve) {
                    console.log(node);
                    const { level } = node;
                    getSysRegionList({ srSuperiorCode: node.value }).then(res => {
                        if (res.data) {
                            const nodes = res.data.map(item => ({
                                value: item.srCode,
                                label: item.srName,
                                leaf: level >= 2
                            }))
                            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                            resolve(nodes);
                        }
                    })
                },

            },
            CityArr: [],
            getAjefShopReceiptTypeList_data: [],
            merchantDetail: {},
            fileList: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],
            fileList5: [],
            fileList6: [],
            totalCountUser: 0,
            isUserShow: false,
            editUser: false,
            formUser: {},
            theRowId: '',
            theAddType: '',
            formUserDatas: {
                currentPage: 1,
                pageSize: 10,
            },
            isMerchantUserShow: false,
            MerchantUserData: [],
            columnsMerchantUser: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ausName",
                    key: "ausName",
                    title: "用户名",
                    align: "center",
                    fixed: 'left',
                    width: 120,
                },
                {
                    field: "ausOpenid",
                    key: "ausOpenid",
                    title: "openId",
                    align: "center",
                    width: 120,
                },
                {
                    field: "ausPhone",
                    key: "ausPhone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "ausType",
                    key: "ausType",
                    title: "权限类型",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ausType == 1 ? <el-tag size="mini" type="danger">普通用户</el-tag> :
                                        row.ausType == 2 ? <el-tag size="mini" type="success">管理员</el-tag> :
                                            <el-tag size="mini" type="success">核销员</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "ausStatus",
                    key: "ausStatus",
                    title: "状态",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ausStatus == 1 ? <el-tag size="mini" type="success">正常</el-tag> :
                                        row.acrStatus == 2 ? <el-tag size="mini" type="danger">已禁用</el-tag> : <el-tag type="danger" size="mini">已删除</el-tag>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleUserEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleUserDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],

            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
                { id: 1, name: "闲置" },
                { id: 2, name: "领用" },
                { id: 3, name: "损坏" },
                { id: 4, name: "丢失" },
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'asaId',
            dialog: false,
            edit: false,
            tableLoading: false,
            form: {
                asBaseBusinessLicense: [],
                asBaseIdcardFace: [],
                asBaseIdcardNationalEmblem: [],
                asBaseShopHeader: [],
                asBaseShopIn: [],
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 200,
                },
                // {
                //     field: "asNumber",
                //     key: "asNumber",
                //     title: "商户编码",
                //     fixed: 'left',
                //     align: "center",
                //     edit: false,
                //     width: 120,
                // },

                {
                    field: "asStatusAgain",
                    key: "asStatusAgain",
                    title: "状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    row.asStatusAgain == 1 ? <el-tag size="mini" >待提交</el-tag> :
                                        row.asStatusAgain == 2 ? <el-tag size="mini" type="danger">待审核</el-tag> :
                                            row.asStatusAgain == 3 ? <el-tag size="success" size="mini">待修改</el-tag> :
                                                row.asStatusAgain == 4 ? <el-tag size="mini" type="danger">已提交</el-tag> :
                                                    row.asStatusAgain == 5 ? <el-tag size="mini" type="danger">已修改</el-tag> : <el-tag type="success" size="mini">禁用商户</el-tag>
                                }
                            </span>
                        );
                    },
                },
                // {
                //     field: "asCity",
                //     key: "asCity",
                //     title: "商户地址",
                //     align: "center",
                //     width: 220,
                // },
                {
                    field: "asBaseBusinessLicense",
                    key: "asBaseBusinessLicense",
                    title: "营业执照照片",
                    edit: false,
                    align: "center",
                    width: 160,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asBaseBusinessLicense ? row.asBaseBusinessLicense.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "asBaseIdcardFace",
                    key: "asBaseIdcardFace",
                    title: "法人身份证人面",
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asBaseIdcardFace ? row.asBaseIdcardFace.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "asBaseIdcardNationalEmblem",
                    key: "asBaseIdcardNationalEmblem",
                    title: "法人身份证国徽",
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asBaseIdcardNationalEmblem ? row.asBaseIdcardNationalEmblem.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    width: 120,
                    field: "asBaseLegalPersonPhone",
                    key: "asBaseLegalPersonPhone",
                    edit: false,
                    title: "法人手机号",
                    align: "center",
                },
                {
                    field: "asBaseShopHeader",
                    key: "asBaseShopHeader",
                    edit: false,
                    title: "门头照片",
                    align: "center",
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asBaseShopHeader ? row.asBaseShopHeader.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "asBaseShopIn",
                    key: "asBaseShopIn",
                    title: "店内照片",
                    width: 200,
                    edit: false,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asBaseShopIn ? row.asBaseShopIn.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },

                {
                    field: "asOpenName",
                    key: "asOpenName",
                    title: "对公账户户名",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asOpenBank",
                    key: "asOpenBank",
                    title: "开户行名称",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asOpenBankAccount",
                    key: "asOpenBankAccount",
                    title: "对公账户账号",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asOpenBankImage",
                    key: "asOpenBankImage",
                    title: "开户许可证",
                    align: "center",
                    edit: false,
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asOpenBankImage ? row.asOpenBankImage.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                // {
                //     field: "asEmail",
                //     key: "asEmail",
                //     title: "邮箱",
                //     align: "center",
                //     edit: false,
                //     width: 140,
                // },
                {
                    field: "asAccountAdminName",
                    key: "asAccountAdminName",
                    title: "管理员姓名",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asAccountAdmin",
                    key: "asAccountAdmin",
                    title: "管理员手机号",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.asAccountAdmin == row.asAccountUser ? 'red' : 'black' }} >{row.asAccountAdmin}</span>
                        );
                    }


                },
                // {
                //     field: "asAccountUserName",
                //     key: "asAccountUserName",
                //     title: "核销员姓名",
                //     align: "center",
                //     edit: false,
                //     width: 140,
                // },
                // {
                //     field: "asAccountUser",
                //     key: "asAccountUser",
                //     title: "核销账号",
                //     align: "center",
                //     edit: false,
                //     width: 140,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span style={{ color: row.asAccountAdmin == row.asAccountUser ? 'red' : 'black' }} >{row.asAccountUser}</span>
                //         );
                //     }
                // },
                {
                    field: "asrtReceiptTypeName",
                    key: "asrtReceiptTypeName",
                    title: "开票结算类型",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                // {
                //     field: "asMainBody",
                //     key: "asMainBody",
                //     title: "主体信息",
                //     align: "center",
                //     edit: false,
                //     width: 120,
                // },
                // {
                //     field: "asMainBusiness",
                //     key: "asMainBusiness",
                //     title: "经营信息",
                //     align: "center",
                //     edit: false,
                //     width: 120,
                // },
                // {
                //     field: "asSettlementAccount",
                //     key: "asSettlementAccount",
                //     title: "结算账户",
                //     align: "center",
                //     edit: false,
                //     width: 120,
                // },
                // {
                //     field: "asWechatAccount",
                //     key: "asWechatAccount",
                //     title: "商户号",
                //     align: "center",
                //     width: 120,
                // },
                // {
                //     field: "asAddress",
                //     key: "asAddress",
                //     title: "商户地址",
                //     align: "center",
                //     width: 120,
                // },



                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "asCheckDes",
                    key: "asCheckDes",
                    title: "审核信息",
                    align: "center",
                    width: 120,
                },

                {
                    field: "asAdminTimeLook",
                    key: "asAdminTimeLook",
                    title: "登录时间",
                    align: "center",
                    fixed: 'right',
                    width: 180,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                          <div> 
                                {row.asAdminTimeLook ? JSON.parse(row.asAdminTimeLook).map((item, index) => {
                                    return (
                                        <div key={index} style="text-align: center;width: 100%;">
                                            {item}
                                        </div>
                                    );
                                }) : ''}
                            </div>

                        );

                    },
                },
                {
                    field: "asaCheckPass",
                    key: "asaCheckPass",
                    title: "审核状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asStatusAgain == 4 ?
                                        <el-button
                                            size="mini" type="text" on-click={() => this.handleCheck(row)} >通过审核 </el-button> : <span></span>
                                }
                                {
                                    row.asStatusAgain == 4 ?
                                        <el-button
                                            size="mini" type="text" style="color:red" on-click={() => this.handleRefuseCheck(row)} >驳回审核 </el-button> : <span></span>
                                }
                            </span>
                        );
                    },
                },


            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                asStatusAgain: 4,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = calcTableHeight(this, this.windheight, 140);
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = calcTableHeight(this, val, 140);
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = calcTableHeight(this, this.windheight, 140);
        getAjefShopReceiptTypeList({ pageSize: 0 }).then(res => {
            this.getAjefShopReceiptTypeList_data = res.data;
        });
        getSysRegionList().then(res => {
            res.data.forEach((item, index) => {
                const obj = {
                    value: item.srCode,
                    label: item.srName,
                    children: [],
                }
                this.CityArr.push(obj)
            })
        })
        getAjefShopCityList({ pageSize: 0 }).then(res => {
            this.getAjefShopCityList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        handleCheckTable(row) {
            this.theRow = row;
            updateAjefShopCheckBefore({ asaId: row.asaId }).then(res => {
                if (res.status == 200) {
                    this.makeData = res.data;
                    this.isMakeShow = true;
                }
            })
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-shop/exportAjefShop',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '商户列表.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        handleChange(value) {
            console.log(value);
            let nodesInfo = this.$refs['cascader'].getCheckedNodes()
            this.form.asCity = nodesInfo[0].pathLabels.join(' ');
            console.log(this.form.asCity, nodesInfo)
        },
        expandChange(e) {
            console.log(e);
        },
        handleTopUpMoney(row) {
            this.$prompt("请输入充值金额?", "确定要充值吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopCheckPassGift({ asaId: row.asaId, giftMoney: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "充值成功!",
                            });

                            // this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleCheck(row) {
            this.$prompt("请输入审核备注?", "确定要审核通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopAgainPass({ asaId: row.asaId, asCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.isMakeShow = false
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck(row) {
            this.$prompt("请输入审核备注?", "确定要拒绝通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjefShopAgainNotPass({ asaId: row.asaId, asCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.isMakeShow = false
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        fileChange(file) {
            if (this.form.asBaseBusinessLicense.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.asBaseBusinessLicense.indexOf(item) == -1) {
                        this.form.asBaseBusinessLicense.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'asBaseBusinessLicense', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter(file) {
            const url = this.form.asBaseBusinessLicense.findIndex(item => item === file)
            this.form.asBaseBusinessLicense.splice(url, 1)
        },
        fileChange2(file) {
            if (this.form.asBaseIdcardFace.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.asBaseIdcardFace.indexOf(item) == -1) {
                        this.form.asBaseIdcardFace.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'asBaseIdcardFace', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter2(file) {
            const url = this.form.asBaseIdcardFace.findIndex(item => item === file)
            this.form.asBaseIdcardFace.splice(url, 1)
        },
        fileChange3(file) {
            if (this.form.asBaseIdcardNationalEmblem.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.asBaseIdcardNationalEmblem.indexOf(item) == -1) {
                        this.form.asBaseIdcardNationalEmblem.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'asBaseIdcardNationalEmblem', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter3(file) {
            const url = this.form.asBaseIdcardNationalEmblem.findIndex(item => item === file)
            this.form.asBaseIdcardNationalEmblem.splice(url, 1)
        },
        fileChange4(file) {
            if (this.form.asBaseShopHeader.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.asBaseShopHeader.indexOf(item) == -1) {
                        this.form.asBaseShopHeader.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'asBaseShopHeader', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter4(file) {
            const url = this.form.asBaseShopHeader.findIndex(item => item === file)
            this.form.asBaseShopHeader.splice(url, 1)
        },
        fileChange5(file) {
            if (this.form.asBaseShopIn.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.asBaseShopIn.indexOf(item) == -1) {
                        this.form.asBaseShopIn.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'asBaseShopIn', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter5(file) {
            const url = this.form.asBaseShopIn.findIndex(item => item === file)
            this.form.asBaseShopIn.splice(url, 1)
        },
        fileChange6(file) {
            if (this.form.asOpenBankImage.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.asOpenBankImage.indexOf(item) == -1) {
                        this.form.asOpenBankImage.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'asOpenBankImage', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter6(file) {
            const url = this.form.asOpenBankImage.findIndex(item => item === file)
            this.form.asOpenBankImage.splice(url, 1)
        },
        addMerchantUser(row) {
            this.theAddType = row;
            this.isUserShow = true;
            this.editUser = false;
        },

        getMerchantUserList() {
            getAjefUserShopList({ asaId: this.theRowId, ...this.formUserDatas }).then(res => {
                this.MerchantUserData = res.data;
                this.totalCountUser = res.total;
            })
        },
        handleMerchantUser(row) {
            this.theRowId = row.asaId;
            this.formUserDatas.asaId = row.asaId;
            getAjefShopDetails({ asaId: row.asaId }).then(res => { this.merchantDetail = res.data })
            getAjefUserShopList({ asaId: row.asaId }).then(res => {
                this.totalCountUser = res.total;
                this.MerchantUserData = res.data;
                this.isMerchantUserShow = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ asaId: this.theRow.asaId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjefShop({ asaIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleUserDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefUserShop({ ausId: row.ausId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.getMerchantUserList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefShop({ asaId: row.asaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleReview(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialogFh = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.asBaseBusinessLicense = data.asBaseBusinessLicense ? data.asBaseBusinessLicense.split(',') : [];
                if (data.asBaseBusinessLicense.length > 0) {
                    this.form.asBaseBusinessLicense.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
                this.form.asBaseIdcardFace = data.asBaseIdcardFace ? data.asBaseIdcardFace.split(',') : [];
                if (data.asBaseIdcardFace.length > 0) {
                    this.form.asBaseIdcardFace.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList2, index, img)
                    })
                }
                this.form.asBaseIdcardNationalEmblem = data.asBaseIdcardNationalEmblem ? data.asBaseIdcardNationalEmblem.split(',') : [];
                if (data.asBaseIdcardNationalEmblem.length > 0) {
                    this.form.asBaseIdcardNationalEmblem.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList3, index, img)
                    })
                }
                this.form.asBaseShopHeader = data.asBaseShopHeader ? data.asBaseShopHeader.split(',') : [];
                if (data.asBaseShopHeader.length > 0) {
                    this.form.asBaseShopHeader.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList4, index, img)
                    })
                }
                this.form.asBaseShopIn = data.asBaseShopIn ? data.asBaseShopIn.split(',') : [];
                if (data.asBaseShopIn.length > 0) {
                    this.form.asBaseShopIn.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList5, index, img)
                    })
                }
                this.form.asOpenBankImage = data.asOpenBankImage && data.asOpenBankImage != 'error' ? data.asOpenBankImage.split(',') : [];
                if (data.asOpenBankImage.length > 0) {
                    this.form.asOpenBankImage.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList6, index, img)
                    })
                }
            })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.asBaseBusinessLicense = data.asBaseBusinessLicense ? data.asBaseBusinessLicense.split(',') : [];
                if (data.asBaseBusinessLicense.length > 0) {
                    this.form.asBaseBusinessLicense.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
                this.form.asBaseIdcardFace = data.asBaseIdcardFace ? data.asBaseIdcardFace.split(',') : [];
                if (data.asBaseIdcardFace.length > 0) {
                    this.form.asBaseIdcardFace.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList2, index, img)
                    })
                }
                this.form.asBaseIdcardNationalEmblem = data.asBaseIdcardNationalEmblem ? data.asBaseIdcardNationalEmblem.split(',') : [];
                if (data.asBaseIdcardNationalEmblem.length > 0) {
                    this.form.asBaseIdcardNationalEmblem.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList3, index, img)
                    })
                }
                this.form.asBaseShopHeader = data.asBaseShopHeader ? data.asBaseShopHeader.split(',') : [];
                if (data.asBaseShopHeader.length > 0) {
                    this.form.asBaseShopHeader.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList4, index, img)
                    })
                }
                this.form.asBaseShopIn = data.asBaseShopIn ? data.asBaseShopIn.split(',') : [];
                if (data.asBaseShopIn.length > 0) {
                    this.form.asBaseShopIn.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList5, index, img)
                    })
                }
                this.form.asOpenBankImage = data.asOpenBankImage && data.asOpenBankImage != 'error' ? data.asOpenBankImage.split(',') : [];
                if (data.asOpenBankImage.length > 0) {
                    this.form.asOpenBankImage.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList6, index, img)
                    })
                }
            })
        },
        handleUserEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.isUserShow = true;
            this.editUser = true;
            this.$nextTick(() => {
                this.formUser = data;
            })
        },
        SureUserBtn() {
            if (!this.editUser) {
                if (this.theAddType == '1') {
                    this.$confirm("是否确定要新增, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.formUser.asaId = this.theRowId
                            addAjefUserShopAdmin(this.formUser).then(res => {
                                if (res.data) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleUserClose()
                                    this.getMerchantUserList()
                                }
                            })
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        })
                }
                if (this.theAddType == '2') {
                    this.$confirm("是否确定要新增, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.formUser.asaId = this.theRowId
                            addAjefUserShopUser(this.formUser).then(res => {
                                if (res.data) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleUserClose()
                                    this.getMerchantUserList()
                                }
                            })
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        })
                }

            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.formUser.asaId = this.theRowId
                        updateAjefUserShop(this.formUser).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleUserClose()
                                this.getMerchantUserList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.asBaseBusinessLicense = newForm.asBaseBusinessLicense ? newForm.asBaseBusinessLicense.toString() : []
                        newForm.asBaseIdcardFace = newForm.asBaseIdcardFace ? newForm.asBaseIdcardFace.toString() : []
                        newForm.asBaseIdcardNationalEmblem = newForm.asBaseIdcardNationalEmblem ? newForm.asBaseIdcardNationalEmblem.toString() : []
                        newForm.asBaseShopHeader = newForm.asBaseShopHeader ? newForm.asBaseShopHeader.toString() : []
                        newForm.asBaseShopIn = newForm.asBaseShopIn ? newForm.asBaseShopIn.toString() : []
                        newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []

                        addAjefShop(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.asBaseBusinessLicense = newForm.asBaseBusinessLicense ? newForm.asBaseBusinessLicense.toString() : []
                        newForm.asBaseIdcardFace = newForm.asBaseIdcardFace ? newForm.asBaseIdcardFace.toString() : []
                        newForm.asBaseIdcardNationalEmblem = newForm.asBaseIdcardNationalEmblem ? newForm.asBaseIdcardNationalEmblem.toString() : []
                        newForm.asBaseShopHeader = newForm.asBaseShopHeader ? newForm.asBaseShopHeader.toString() : []
                        newForm.asBaseShopIn = newForm.asBaseShopIn ? newForm.asBaseShopIn.toString() : []
                        newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []
                        updateAjefShop(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        SureBtnFs() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.form))
                    newForm.asBaseBusinessLicense = newForm.asBaseBusinessLicense ? newForm.asBaseBusinessLicense.toString() : []
                    newForm.asBaseIdcardFace = newForm.asBaseIdcardFace ? newForm.asBaseIdcardFace.toString() : []
                    newForm.asBaseIdcardNationalEmblem = newForm.asBaseIdcardNationalEmblem ? newForm.asBaseIdcardNationalEmblem.toString() : []
                    newForm.asBaseShopHeader = newForm.asBaseShopHeader ? newForm.asBaseShopHeader.toString() : []
                    newForm.asBaseShopIn = newForm.asBaseShopIn ? newForm.asBaseShopIn.toString() : []
                    newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []
                    addAjefShopAgain(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.fileList = [];
            this.fileList2 = [];
            this.fileList3 = [];
            this.fileList4 = [];
            this.fileList5 = [];
            this.fileList6 = [];
        },
        // 关闭弹框
        handleUserClose() {
            this.isUserShow = false;
            this.editUser = false;
            this.$refs['formRef2'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.asaId = row.asaId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageSizeChange_User(pageSize) {
            this.formUserDatas.pageSize = pageSize;
            this.getMerchantUserList();
        },
        pageNumberChange_user(pageIndex) {
            console.log(pageIndex);
            this.formUserDatas.currentPage = pageIndex;
            getAjefUserShopList(this.formUserDatas).then((res) => {
                this.MerchantUserData = res.data;
                this.totalCountUser = res.total;
                // this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefShopAgainList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefShopAgainList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefShopAgainList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>